import * as basicScroll from 'basicscroll';

const parallax = () => {
  document
    .querySelectorAll('.c-intro__image--parallax,.c-intro__headline--parallax')
    .forEach(elem => {
      const modifier = elem.getAttribute('data-modifier');

      basicScroll
        .create({
          elem,
          from: 0,
          to: 800,
          direct: true,
          props: {
            '--translateY': {
              from: '0',
              to: `${10 * modifier}px`,
            },
          },
        })
        .start();
    });
};

parallax();

const introHeight = () => {
  const intros = document.querySelectorAll('.c-intro');
  if (intros) {
    intros.forEach(intro => {
      const facts = intro.querySelector('.c-intro__facts');
      const parallaxGroup = intro.querySelector('.c-intro__parallax-group');
      if (facts && parallaxGroup) {
        parallaxGroup.style.maxHeight = `calc(${intro.offsetHeight}px - ${
          facts.offsetHeight
        }px`;
      }
    });
  }
};

window.addEventListener('resize', () => {
  introHeight();
});
introHeight();
